import { deleteInternalCategory, useInternalCategories } from '@gozoki/api';
import { Button, TextField } from '@mui/material';
import { useMemo, useState } from 'react';

import { includesLowerCase } from '@gozoki/tools';
import { GridColDef } from '@mui/x-data-grid';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ConfirmResourceDeletionButton } from '../../components/communication/ConfirmDeletionButton';
import SimpleDataGrid from '../../components/containers/SimpleDataGrid';
import { ROUTE_BUILDER } from '../../utils/constants/routes.constants';
import { useRights } from '../../utils/hooks';

const internalCategoriesColDef: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 150 },
    { field: 'name', headerName: 'Nom', width: 200 },
];

export const InternalCategoriesPanel = () => {
    const navigate = useNavigate();
    const isUserAdmin = useRights(['ADMIN']);

    const [search, setSearch] = useState('');
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);

    const {
        data: internalCategories = [],
        refetch,
        isLoading,
        isRefetching,
        isPending,
    } = useInternalCategories();

    // Transform fetched categories into DataGrid format
    const internalCategoriesRows = useMemo(() => {
        return internalCategories.filter((category) => includesLowerCase(category.name, search));
    }, [internalCategories, search]);

    const deleteCategoryMut = useMutation({ mutationFn: deleteInternalCategory });

    const handleDeleteCategory = () => {
        const deletionPromise = deleteCategoryMut.mutateAsync(selectedCategories, {
            onSuccess: () => {
                refetch();
            },
        });
        setSelectedCategories([]); // Avoid disabled button flickering
        return deletionPromise;
    };

    const navigateAndUpdateCategory = () => {
        navigate(ROUTE_BUILDER.updateInternalCategory(selectedCategories[0]));
    };

    const categoriesDisabled = selectedCategories.length === 0 || deleteCategoryMut.isPending;

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', padding: '16px' }}>
                <TextField
                    variant="outlined"
                    label="Recherche"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <div style={{ flexGrow: 1 }} />
                <ConfirmResourceDeletionButton
                    handleResourceDeletion={handleDeleteCategory}
                    disabled={!isUserAdmin ? true : categoriesDisabled}
                />
                <Button
                    variant="contained"
                    sx={{ height: '36px' }}
                    disabled={categoriesDisabled}
                    onClick={navigateAndUpdateCategory}
                >
                    {isUserAdmin ? 'Modifier' : 'Voir'}
                </Button>
            </div>
            <SimpleDataGrid
                rowHeight={70} // For image display
                columns={internalCategoriesColDef}
                rows={internalCategoriesRows}
                loading={isLoading || isPending || isRefetching}
                onRowSelectionModelChange={(newSelection) =>
                    setSelectedCategories(newSelection as number[])
                }
            />
        </>
    );
};
